import React from 'react';
import classNames from 'classnames/bind';
import { Typography, Icon } from 'gd-design-library';
import { Button } from '@components';
import { Tenant } from '@utils/TenantContext';
import { TenantState } from '@constants/tenant';
import { colors } from 'theme/colors';
import styles from './TenantsTable.module.scss';

const cx = classNames.bind(styles);

const CN = 'tenants-table';
const tableClassName = CN;
const narrowTableHeaderClassName = `${CN}__narrow-header`;
const statusCellClassName = `${CN}__status-cell`;
const chipClassName = `${CN}__chip`;
const infoIconClassName = 'info-icon';

const tenantStateColorMap: Record<TenantState, string> = {
  [TenantState.READY]: colors.green,
  [TenantState.IMPORTING]: colors.blue,
  [TenantState.FAILED]: colors.alert.red,
  [TenantState.REMOVING]: colors.orange
};

interface TenantsTableProps {
  tenants: Tenant[];
  onCopyTenantLink: (tenantKey: string) => void;
  onDeleteTenant: (tenantKey: string) => void;
  onShowStatusDetails: (tenantKey: string) => void;
}

const TenantsTable: React.FC<TenantsTableProps> = ({
  tenants,
  onCopyTenantLink,
  onDeleteTenant,
  onShowStatusDetails
}) => (
  <table className={ cx(tableClassName) }>
    <thead>
      <tr>
        <th><Typography variant='small'>Name</Typography></th>
        <th><Typography variant='small'>Key</Typography></th>
        <th className={ cx(narrowTableHeaderClassName) }>
          <Typography variant='small'>State</Typography>
        </th>
        <th className={ cx(narrowTableHeaderClassName) }>
          <Typography variant='small'>Copy Link</Typography>
        </th>
        <th className={ cx(narrowTableHeaderClassName) }>
          <Typography variant='small'>Remove</Typography>
        </th>
      </tr>
    </thead>
    <tbody>
      {tenants.map(tenant => (
        <tr key={ tenant.id }>
          <td><Typography variant='small'>{tenant.name}</Typography></td>
          <td><Typography variant='small'>{tenant.key}</Typography></td>
          <td>
            <div className={ cx(statusCellClassName) }>
              <div
                className={ cx(chipClassName) }
                style={ { backgroundColor: tenantStateColorMap[tenant.state] || colors.neutral['grey.40'] } }
              >
                <Typography variant='small' color={ colors.neutral.white }>{tenant.state}</Typography>
              </div>
              {tenant.stateDetails && (
                <Button
                  variant='text'
                  isIcon
                  onClick={ (): void => onShowStatusDetails(tenant.key) }
                  className={ cx(infoIconClassName) }
                >
                  <Icon name='info' width={ 18 } height={ 18 } />
                </Button>
              )}
            </div>
          </td>
          <td>
            <Button
              variant='text'
              isIcon
              onClick={ (): void => onCopyTenantLink(tenant.key) }
              disabled={ tenant.state !== TenantState.READY }
            >
              <Icon name='contentCopy' width={ 20 } height={ 20 } />
            </Button>
          </td>
          <td>
            <Button
              variant='text'
              isIcon
              onClick={ (): void => onDeleteTenant(tenant.key) }
              disabled={ tenant.state === TenantState.IMPORTING || tenant.state === TenantState.REMOVING }
              style={ { color: colors.alert.red } }
            >
              <Icon name='deleteOutlined' width={ 24 } height={ 24 } />
            </Button>
          </td>
        </tr>
      ))}
    </tbody>
  </table>
);

export default TenantsTable;
